import { render, staticRenderFns } from "./FilterUploadFile.vue?vue&type=template&id=070ca0c8&scoped=true&"
import script from "./FilterUploadFile.vue?vue&type=script&lang=js&"
export * from "./FilterUploadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ca0c8",
  null
  
)

export default component.exports